<template>
    <div class="tab-content">
        <medication-form v-show="physician.NetworkTab"></medication-form>
        <record-form v-show="physician.NetworkTab"></record-form>

        <email-form v-show="physician.EmailTabs"></email-form>
        <record-form v-show="physician.EmailTabs"></record-form>

        <hippa-form v-show="physician.HipaaTab"></hippa-form>
        <record-form v-show="physician.HipaaTab"></record-form>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PhysicianMixin from 'mixins/PhysicianMixin'
    import RecordForm from 'components/forms/record-request/RecordForm'
    import MedicationForm from 'components/forms/medication-network/MedicationForm'
    import EmailForm from 'components/forms/email-request/EmailForm'
    import HippaForm from 'components/forms/hippa/HippaForm'

    export default {
        mixins: [FormMixin, HandleRequestMixin, PhysicianMixin],
        components: {
            RecordForm,
            MedicationForm,
            EmailForm,
            HippaForm,
        },
        props: {
            physician: { type: Object, required: true },
        },
        methods: {},
    }
</script>
